import React from 'react';
import moment from 'moment';

const quickIncrement = (event) => {
	event.currentTarget.classList.remove('saved');
	void event.currentTarget.offsetWidth;
	event.currentTarget.classList.add('saved');
}

export default props => (
	<div className="SET">
		<div className="heading">
			<div className="name">{props.set.name}</div>
			<ul className="actions">
				<li><label htmlFor="panel-home">BACK</label></li>
				<li><span onClick={() => props.handleSelectModal('EDIT-SET', { name: props.set.name })}>RENAME</span></li>
				<li><span onClick={() => props.handleSelectModal('DELETE-SET', { name: props.set.name })}>DELETE</span></li>
			</ul>
		</div>

		<ul className="tallies">
			{props.set.tallies && props.set.tallies.map(tally => (
				<li key={tally.id}>
					<button className="button alt-increment" onClick={event => {
						props.handleEditMark('NEW', {
							datetime: moment().format('YYYY-MM-DDTHH:mm'),
							comment: '',
							setId: props.selectedSet,
							tallyId: tally.id,
							markId: null
						});
						quickIncrement(event);
					}}>
						<span className="line-a"></span>
						<span className="line-b"></span>
						<svg className="check" viewBox="0 0 60 60"><path d="M 5.65686 14.1421L 0 8.48529L 1.41422 7.07108L 7.07108 12.7279L 19.799 0L 21.2132 1.41422L 8.48529 14.1421L 7.07108 15.5564L 5.65686 14.1421Z" transform="translate(19 22)" fill="#333"/></svg><svg className="plus" viewBox="0 0 60 60"><path d="M 0 0L 60 0L 60 60L 0 60L 0 0Z" fill="#333"/><path d="M 11 0L 9 0L 9 9L 0 9L 0 11L 9 11L 9 20L 11 20L 11 11L 20 11L 20 9L 11 9L 11 0Z" transform="translate(20 20)" fill="#fff"/></svg>
					</button>

					<div className="details" onClick={() => {props.handleSelectPanel('TALLY', { tallyId: tally.id })}}>
						<span className="count">{tally.marks ? tally.marks.length : '0'}</span>
						<span className="name">{tally.name}</span>
						
						{tally.marks ? (
							<span className="date">{moment(tally.marks[0].datetime).fromNow()}</span>
						) : (
							<span className="empty">Never</span>
						)}
					</div>
				</li>
			))}
		</ul>
		
		<div className="primary-action">
			<button className="button alt-add-tally" onClick={() => props.handleSelectModal('ADD-TALLY')}>Add Tally</button>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/set-panel.js